import { render, staticRenderFns } from "./pie-ring.vue?vue&type=template&id=43f6f0a6&"
import script from "./pie-ring.vue?vue&type=script&lang=js&"
export * from "./pie-ring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports